import Image from 'next/image';

import clsx from 'clsx';

import PropTypes from 'prop-types';

const AlbumTypeCard = ({ title, description, isSelected, onClick, image, ...restProps }) => {
    return (
        <div className="mx-auto flex h-full max-w-[210px] flex-1 rounded-[7px] bg-white px-px py-px dark:bg-icoDarkMode-anthracite">
            <button
                onClick={onClick}
                className={clsx(
                    'flex h-full w-full flex-col items-center justify-center rounded-md border border-solid border-icoGray-100 dark:border-icoDarkMode-anthracite',
                    {
                        'ring-2 ring-icoBlue focus:ring-icoBlue focus:ring-offset-0': isSelected,
                        'focus:ring-0': !isSelected
                    }
                )}
                {...restProps}>
                <span
                    className={clsx(
                        'relative flex h-32 w-full justify-center rounded-t-md bg-icoGray-100 dark:bg-icoDarkMode-deepBlack',
                        {
                            'grayscale filter': !isSelected
                        }
                    )}>
                    <Image
                        src={image}
                        alt=""
                        width={206}
                        height={128}
                        style={{ objectFit: 'cover' }}
                    />
                </span>
                <span className="flex flex-1 flex-col items-center justify-center space-y-2 p-5">
                    <span
                        className={clsx('text-sm', {
                            'text-icoBlue': isSelected,
                            'text-icoBlack dark:text-white': !isSelected
                        })}>
                        {title}
                    </span>
                    <span className="flex flex-1 pb-1 text-center font-GMedium text-xs text-icoGray-500 dark:text-icoDarkMode-wolf">
                        {description}
                    </span>
                </span>
            </button>
        </div>
    );
};

export default AlbumTypeCard;

AlbumTypeCard.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.string,
    isSelectedd: PropTypes.bool,
    onClick: PropTypes.func
};
